// React and Redux imports
import { useDispatch, useSelector } from 'react-redux';

// Chakra UI components
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

// Actions and constants
import { deleteLearningPlanAction } from 'store/modules/learningPlan/learningPlan-action';
import { learningPlanActions } from 'store/modules/learningPlan/learningPlan-slice';
import { ReducerStatus } from 'utils/constants';

// Common components
import ResultModal from 'components/common/modals/ResultModal';

function DeleteLearningPlanMd() {
  const dispatch = useDispatch();

  // Select delete learning plan state from Redux store
  const deleteLearningPlan = useSelector(
    (state) => state.learningPlan.deleteLearningPlan
  );

  // Toggle the delete learning plan modal
  const handleToggleDeleteModal = (isOpen) => {
    dispatch(learningPlanActions.setDeleteLearningPlan({ modal: isOpen }));
  };

  // Dispatch action to delete sub-quest learning plan
  const handleDeleteLearningPlan = () => {
    dispatch(deleteLearningPlanAction(deleteLearningPlan.id));
  };

  // Reset the delete learning plan status
  const handleResultButton = () => {
    dispatch(
      learningPlanActions.setDeleteLearningPlan({
        modal: false,
        learningPlanId: null,
        courseId: null,
        status: ReducerStatus.IDLE,
        error: null,
      })
    );
  };

  return (
    <Box>
      {/* Show ResultModal if the delete operation succeeded or failed */}
      {deleteLearningPlan.status === ReducerStatus.SUCCEEDED ||
      deleteLearningPlan.status === ReducerStatus.FAILED ? (
        <ResultModal
          isOpen={deleteLearningPlan.modal}
          onSubmit={handleResultButton}
          isError={deleteLearningPlan.status === ReducerStatus.FAILED}
          title={
            deleteLearningPlan.status === ReducerStatus.SUCCEEDED
              ? 'Deleted'
              : 'Server Error'
          }
          message={
            deleteLearningPlan.status === ReducerStatus.SUCCEEDED
              ? 'The selected learning plan has been deleted successfully. If you believe this was done in error, please contact the administrator.'
              : deleteLearningPlan.error?.data?.title || 'Server Error'
          }
          errorObject={deleteLearningPlan.error?.data?.errors}
        />
      ) : (
        // Show confirmation modal for delete operation
        <Modal
          isOpen={deleteLearningPlan.modal}
          onClose={() => handleToggleDeleteModal(false)}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Confirmation Required</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              Are you sure you want to delete this learning plan? Please note
              that before the deletion process, the system will check if this
              learning plan is bound to any classes and will require you to
              unbind it.
            </ModalBody>

            <ModalFooter>
              {/* Close button */}
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => handleToggleDeleteModal(false)}
              >
                Close
              </Button>
              {/* Proceed button */}
              <Button
                variant="outline"
                colorScheme="red"
                isLoading={deleteLearningPlan.status === ReducerStatus.LOADING}
                onClick={() => handleDeleteLearningPlan()}
              >
                Proceed
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
}

export default DeleteLearningPlanMd;
